import { useState } from "react";
import { useTranslation } from "react-i18next";

import Toast from "../components/Toast";
import TwoFactorCard from "../components/TwoFactorCard";

/** The signed-in user's own security settings — currently just 2FA. */
export default function Security({ user }) {
  const { t } = useTranslation();
  const [toast, setToast] = useState(null);

  return (
    <div>
      <div className="mb-5">
        <h1 className="text-xl font-bold">{t("security.title")}</h1>
        <p className="text-sm text-ink-2">
          {user?.email ? t("security.subtitleFor", { email: user.email }) : t("security.subtitle")}
        </p>
      </div>

      <TwoFactorCard onToast={setToast} />

      <Toast toast={toast} onClose={() => setToast(null)} />
    </div>
  );
}
